import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_PARTNERS_LIST,
  CPM_CREATE_PARTNER,
  CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/partner';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmPartner;
const partner = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullPartner') {
        return {
          ...state,
          list: { ...initialSettings.list },
          updateFinancialInformation: { ...initialSettings.updateFinancialInformation },
        };
      }
      switch (action.target) {
        case 'updatePartnerFinancialInformation':
          key = 'updateFinancialInformation';
          break;
        case 'addPartner':
          key = 'add';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // CPM_GET_PARTNERS_LIST
    case CPM_GET_PARTNERS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
          },
        },
      };
    case `${CPM_GET_PARTNERS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_PARTNERS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: null,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listPartners.entries),
            pageNumber: _parseInt(action.data.listPartners.pageNumber),
            pageSize: _parseInt(action.data.listPartners.pageSize),
            totalEntries: _parseInt(action.data.listPartners.totalEntries),
            totalPages: _parseInt(action.data.listPartners.totalPages),
          },
        },
      };

    // CPM_CREATE_PARTNER
    case CPM_CREATE_PARTNER:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case `${CPM_CREATE_PARTNER}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_CREATE_PARTNER}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };

    // CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION
    case CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION:
      return {
        ...state,
        updateFinancialInformation: {
          ...state.updateFinancialInformation,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION}_ERROR`:
      return {
        ...state,
        updateFinancialInformation: {
          ...state.updateFinancialInformation,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION}_SUCCESS`:
      return {
        ...state,
        updateFinancialInformation: {
          ...state.updateFinancialInformation,
          updated: true,
          result: deserialize(action.data.updatePartnerFinancialInformation),
        },
      };
    default:
      return state;
  }
};

export default partner;



// WEBPACK FOOTER //
// ./reducers/cpm/partner/partner.js